module.exports = __webpack_public_path__ + "assets/images/cosmote_sport_9.8715f1fbd20149b726098b49b9de7b87.png";